module.exports = __webpack_public_path__ + "img/tacna-mock-up.d7051cab.jpg";